import type { Season } from '../seasons/SeasonTypes';

/**
 * Binding rules for every kingdom renderer. Large authored scene backdrops,
 * settlement-wide road composites and fixed river/lake composites are not
 * allowed: they would make different seeds converge on the same picture.
 */
export const DYNAMIC_WORLD_RULES = Object.freeze({
  stageBackdrops: false,
  terrainSource: 'generated-map-tiles',
  roadSource: 'generated-road-neighbor-graph',
  waterSource: 'generated-water-neighbor-graph',
  buildingSource: 'live-world-snapshot',
  decorationSource: 'seeded-world-generation',
  seasonSource: 'live-season-state',
  cameraSource: 'live-building-bounds',
});

export function seasonalBuildingKey(baseKey: string, season?: Season): string {
  return season === 'winter' ? `${baseKey}_winter` : baseKey;
}

export function castleStageKey(level: number, season?: Season): string {
  const safeLevel = Math.max(1, Math.min(6, Math.floor(level)));
  return seasonalBuildingKey(`voxel/castle/stage_${safeLevel}`, season);
}

export function seasonalTerrainKey(assetName: string, season?: Season): string {
  return season ? `seasonal/${season}/${assetName}` : assetName;
}
